import { RoleState, RootState } from '@/types';
import { GetterTree, MutationTree, ActionTree, Module } from 'vuex';
import RoleService from '@/services/role.service';

type RoleGetter = GetterTree<RoleState, RootState>;

export const initialState = (): RoleState => {
  return {
    initialState,
    roles: [],
  };
};

export const getters: RoleGetter = {
  roles: (state) => state.roles,
  getRoleById: (state) => (id: number) => state.roles.find((item: any) => item.id === id),
};

export const mutations: MutationTree<RoleState> = {
  addRoles(state, newRoles) {
    state.roles = newRoles.roles;
  },
};

export const actions: ActionTree<RoleState, RootState> = {
  async addRolesAsync(context, projectId) {
    const rolesResp = await RoleService.getOrganisationRoles();
    context.commit('addRoles', rolesResp);
  },
};


export const roles: Module<RoleState, RootState> = {
  state: initialState(),
  getters,
  mutations,
  actions,
};
